<template>
  <div>
    <!-- navigation -->
    <div class="nav-links">	
      <nav class="navbar navbar-inverse">

        <div class="container" style="width: 100%;">
          <div
            id="navbar"
            class="collapse navbar-collapse"
          >   
            <ul class="nav navbar-nav link-effect">        
              <li   style="width: 50px;">
                <div id="logo" style="width: 50px; display:flex;   ;margin-top: 15px;"><img style="width: 50px;" src="img/icons/favicon-16x16.png"></div>
              </li>
              <li   style="float: left;">            
                <div   style="
            
                  display: flex;
                  font-size: 30px;
                  margin-top: 20px;
                  font-weight: bold;
                  font-family: 'Noto Sans SC'
                  ">&nbsp;太药集团</div>
                      </li> 
                      <li style="margin-left: 100px;" class="active">
                        <router-link to="/">
                          首页
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/about">
                          关于太药
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/news">
                          新闻中心
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/products">
                          产品中心
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/technologyView">
                          科技研发
                        </router-link>
                      </li>
                      <!-- <li>
                        <router-link to="/home">
                          国际化
                        </router-link>
                      </li> -->
                      <!-- <li>
                        <router-link to="/home">
                          通知公告
                        </router-link>
                      </li> -->
                      <!-- <li>
                        <router-link to="/developmentHistory">
                          发展历程
                        </router-link>
                      </li> -->
                      <li>
                        <router-link to="/contactUs">
                          联系我们
                        </router-link>
                      </li>
                      <li class="dropdown">
                        <a
                          href="#"
                          class="dropdown-toggle"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        ><span data-hover="Short Codes"> <router-link to="/talent-philosophy">人力资源</router-link></span> <b class="caret" /></a>
                        <ul class="dropdown-menu agile_short_dropdown">
                          <li>     <router-link to="/talent-philosophy">
                                     人才理念
                        </router-link></li>
                          <li><router-link to="/learnerBeliefView">
                                     学习理念‌
                        </router-link></li>
                          <li>  <router-link to="/‌socialRecruitment">招聘信息 </router-link></li>
                          <li><router-link to="/shenghuo">生活在太药</router-link></li>
                        </ul>  
                      </li>
                    </ul>
                  </div>
                </div>
      </nav>
    </div>
    <!-- /navigation -->
  </div>
</template>
<style scoped>
a {
    color: unset;
    text-decoration: none;
}
.nav-links {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 100;
}
li{
  width: 150px;
}
</style>
<script lang="js">

window.onload = function() {
  document.querySelectorAll('#navbar ul li').forEach(function(link) {
   link.addEventListener('click', function() {
  // 移除其他项的active类
  document.querySelectorAll('#navbar ul li').forEach(function(otherLink) {
    otherLink.classList.remove('active');
  });
  // 给当前项添加active类
  this.classList.add('active');
});
});
};
</script>
